export class CartProductItem {
    discount= 0;
    quantity= 0;
    priceBase= 0;
    price= 0;
    priceNet= 0;
    priceVat= 0;
    product: any = {}
    title = ''
    preferences: any[] = []
    notes = ''
    useRitmitos=false;
}

export default class CartModel {
    totalPrice= 0.0;
    totalVat= 0.0;
    totalNet= 0.0;
    totalProducts = 0;
    orderId? = '';
    products: CartProductItem[] = [];
    useRitmitos = false;
    ritmitosAvailable = 0;
    ritmitosInOrders = 0;
    addressId= 0;
    transport:any
    transportPrice:any
}

export interface CartItemModel
{
    quantity: number,
    preferences: any[],
    priceOld: number,
    priceFinal: number,
    priceFinalNet: number,
    priceFinalVat: number,
    priceBase: number
}